import { StreamChat } from "stream-chat";
import { env } from "@/config/runtimeEnv";

const GET_STREAM_API_KEY = env("REACT_APP_GET_STREAM_API_KEY");
if (!GET_STREAM_API_KEY) {
  console.error("REACT_APP_GET_STREAM_API_KEY environment variable is not set");
}

const fallbackKey = GET_STREAM_API_KEY ?? "some-api-key";

export const getStreamChatSingleton = (): StreamChat =>
  StreamChat.getInstance(fallbackKey);

let internalClientInstance: StreamChat | null = null;

const getInternalStreamChatInstance = (): StreamChat => {
  if (internalClientInstance === null) {
    internalClientInstance = new StreamChat(fallbackKey);
  }
  return internalClientInstance;
};

let guestConnectionChain: Promise<void> = Promise.resolve();

export const getStreamChatClient = (
  userId: string,
  token: string,
): Promise<StreamChat> => {
  const client = getStreamChatSingleton();
  const task = guestConnectionChain.then(async () => {
    if (client.userID === userId) {
      return client;
    }
    if (client.userID) {
      await client.disconnectUser();
    }
    await client.connectUser({ id: userId }, token);
    return client;
  });
  guestConnectionChain = task.then(
    () => undefined,
    () => undefined,
  );
  return task;
};

let internalConnectionChain: Promise<void> = Promise.resolve();

export const getInternalStreamChatClient = (
  userId: string,
  token: string,
): Promise<StreamChat> => {
  const client = getInternalStreamChatInstance();
  const task = internalConnectionChain.then(async () => {
    if (client.userID === userId) {
      return client;
    }
    if (client.userID) {
      await client.disconnectUser();
    }
    await client.connectUser({ id: userId }, token);
    return client;
  });
  internalConnectionChain = task.then(
    () => undefined,
    () => undefined,
  );
  return task;
};
